import { Component, computed, EventEmitter, inject, Input, Output } from '@angular/core';
import { TtmTicket } from '../../classes/ttm-ticket.class';
import { CodaltComponent } from '../codalt/codalt.component';
import { AuthenticationService } from './../../services/auth/authentication.service';
import { LocalStorage } from '../../utils/storage';

@Component({
    selector: 'app-ttm-ticket-card',
    templateUrl: './ttm-ticket-card.component.html',
    styleUrls: ['./ttm-ticket-card.component.scss']
})
export class TtmTicketCardComponent extends CodaltComponent {
    @Input() ticket: TtmTicket;
    @Input() canDeleteTicket = false;
    @Output() deleteTicket = new EventEmitter<TtmTicket>();

    isNewTicket = computed(() => {
        return this.ticket.status === 'new' && (this.ticket.assignee_id === LocalStorage.user?.id || this.ticket.user_id === LocalStorage.user?.id);
    });

    authService = inject(AuthenticationService);

    constructor() {
        super();
    }
}
